const CouponTypeReachAmount = 1
const CouponTypeProduct = 2

const DiscountTypeAmount = 1
const DiscountTypePercentage = 2

const PublishStatusPublished = 1
const PublishStatusOff = 2

const app = function () {

  this.definedType = function(data) {
    console.log(`definedType`,data)
    if(data.CouponType == CouponTypeReachAmount && data.DiscountType == DiscountTypeAmount) return '固定金額折扣'
    if(data.CouponType == CouponTypeProduct && data.DiscountType == DiscountTypeAmount) return '指定商品折扣'
    if(data.CouponType == CouponTypeReachAmount && data.DiscountType == DiscountTypePercentage) return '百分比折扣'
    return "資料異常"
  }

  return this
}
export default app
